var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invoicesGrid"},_vm._l((_vm.state.admin.global.invoices.list),function(invoice,index){return _c('invoice-card',{key:index,attrs:{"invoice":invoice},on:{"click":function($event){_vm.state.invoicesView = 'details'; _vm.state.user.invoices.activeInvoice = invoice}}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77047b56","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/system/organisms/invoicesGrid.vue
// module id = null
// module chunks = 